// @ts-nocheck
/**
 * SERVIÇO DE INTEGRAÇÃO - FC ANÁLISES
 *
 * O navegador NÃO possui credenciais da FC.
 * Toda comunicação externa passa pelas Cloud Functions.
 */

import { httpsCallable } from "firebase/functions";
import { functions } from "../config/firebase";

const getCurrentEnvironment = () => {
  const host = window?.location?.hostname || "";

  if (host.includes("homolog") || host.includes("localhost")) {
    return "homolog";
  }

  return "production";
};

export const enviarSolicitacaoFC = async (solicitacao, pretendente) => {
  const callable = httpsCallable(functions, "fcEnviarSolicitacao");

  const response = await callable({
    solicitacao,
    pretendente,
    environment: getCurrentEnvironment(),
  });

  return response.data;
};

export const consultarSolicitacaoFC = async (solicitationId) => {
  const callable = httpsCallable(functions, "fcConsultarSolicitacao");

  const response = await callable({
    solicitationId,
    environment: getCurrentEnvironment(),
  });

  return response.data;
};

export const consultarLaudoFC = async (solicitationId) => {
  const callable = httpsCallable(functions, "fcConsultarLaudo");

  const response = await callable({
    solicitationId,
    environment: getCurrentEnvironment(),
  });

  return response.data;
};

export const getLinkLaudoPDF = async (solicitationId) => {
  const callable = httpsCallable(functions, "fcObterPdf");

  const response = await callable({
    solicitationId,
    environment: getCurrentEnvironment(),
  });

  return response.data?.url || "";
};

export const cadastrarWebhookFC = async () => {
  const callable = httpsCallable(functions, "fcCadastrarWebhook");

  const response = await callable({
    environment: getCurrentEnvironment(),
  });

  return response.data;
};
